// extracted by mini-css-extract-plugin
export default {"left_right_wrap":"style_left_right_wrap__cxGIj"};